import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Catch } from "../utils";
import { CaseRouter, lazyLoad, SchoolRouter, StudentRouter, SystemRouter, UsaeduRouter } from "./main";
import { RouteObjectRule } from "./router";
import WebsiteRouter from "./website";
import GotousRouter from "./gotous";

import MentorRouter from "./mentorbook";
import MisRouter from "./mis";
import QzwdRouter from "./qzwd";

const Layout = lazy(() => import("../Layout"));
const ErrorPage = lazy(() => import("../Layout/ErrorPage"));
const Home = lazy(() => import("../pages/Home"));
const Login = lazy(() => import("../pages/Login"));

const routerData: RouteObjectRule[] = [
	{
		path: "/",
		element: <Layout />,
		children: [
			{
				index: true,
				element: lazyLoad(<Home />),
				key: 'default',
			},
			{
				path: "/home",
				element: lazyLoad(<Home />)
			},
			...UsaeduRouter,
			...CaseRouter,
			...SystemRouter,
			...SchoolRouter,
			...StudentRouter,
			...WebsiteRouter,
			...GotousRouter,
			...MentorRouter,
			...MisRouter,
			...QzwdRouter
		]
	},
	{
		path: "/login",
		element: lazyLoad(<Login />),
		meta: {
			islogin: true
		}
	},
	// {
	//     path: "*",
	//     element: <Navigate to="/home" replace />
	//  }
];

const routerDom: any = (rt: RouteObjectRule[]) => {
	const access_token = Catch.get('access_token');
	return (
		rt.map((item) => {
			return <Route key={item.path ? item.path : item['key']}
				path={item.path}
				index={!!item.index}
				element={(!item.meta?.islogin && !access_token) ? <Navigate to='/login' replace={true} /> : item.element}
				errorElement={item.errorElement ?? <ErrorPage />}
			>
				{(item.children && item.children.length > 0) ? routerDom(item.children) : null}
			</Route>
		})
	)
}

const MyRouter = () => {
	return <Routes>
		{routerDom(routerData)}
	</Routes>
}

export default MyRouter;
